import BasePicker from './BasePicker.vue'

export default BasePicker